// extracted by mini-css-extract-plugin
var _1 = "ApplicantProfileDocumentsRow-moduleApplicantProfileDocumentsRow__xtkxv ApplicantProfileDocumentsMockTable-modulerow__BRqCr TableComponent-modulerow__xPAo4";
var _2 = "ApplicantProfileDocumentsRow-modulenameCell__ZzkBG TableCellBase-moduleTableCellBase__GDcv6 TableCell-moduleTableCell__hIV2f";
export { _1 as "ApplicantProfileDocumentsRow", _2 as "nameCell" }
